/**
 * Wahler-Backend
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export enum AttributeConsistencyResolution {

    MANUALLY_ACCEPTED = 'MANUALLY_ACCEPTED',

    CLARIFICATION_REQUIRED = 'CLARIFICATION_REQUIRED'
}

